import { render } from "./SerchBoxDockView.vue?vue&type=template&id=279c7cf6&scoped=true&ts=true"
import script from "./SerchBoxDockView.vue?vue&type=script&lang=ts"
export * from "./SerchBoxDockView.vue?vue&type=script&lang=ts"

import "./SerchBoxDockView.vue?vue&type=style&index=0&id=279c7cf6&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279c7cf6"]])

export default __exports__